<div class="container-flui">
    <div class="row caja" style="min-height: 550px;">
        <cdk-virtual-scroll-viewport itemSize="20" class="example-viewport">
            <mat-accordion>
<!--                 <ng-container *ngFor="let noticia of noticias">
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{noticia.title}}
                            </mat-panel-title>
                            <mat-panel-description>
                                {{noticia.date}}
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <p>{{noticia.text}}</p>
                    </mat-expansion-panel>
                </ng-container> -->
                <div *cdkVirtualFor="let noticia of noticias" class="example-item">
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{noticia.title}}
                        </mat-panel-title>
                        <mat-panel-description>
                          {{noticia.date}}
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <p>{{noticia.text}}</p>
                    </mat-expansion-panel>
                  </div>
            </mat-accordion>
        </cdk-virtual-scroll-viewport>
    </div>
</div>